<template>
  <div :class="xs ? '' : 'd-flex flex-column full-height'" style="flex: 1" :style="`${height ? `height:${height}` : ''}`">
    <div class="d-flex flex-column">
      <div class="op-text-l" v-if="showDate">{{ mx_getDutyDate(duty) }}</div>
      <div class="d-flex">
        <v-chip class="mr-3 accent white--text op-text" v-if="dutyTime">{{ dutyTime }}</v-chip>
        <v-chip class="mr-3 grey darken-1 white--text op-text" v-if="locationFromTo"> {{ locationFromTo }}</v-chip>
      </div>
    </div>

    <div class="d-flex flex-column">
      <div class="op-text pt-2 pl-1" v-for="(c, ind) in vehicleLocation" :key="ind">{{ c }}</div>
    </div>
  </div>
</template>

<script>
import dutyMixin from '../common/dutyMixin';
import commonMixin from '@/mixins/common';
import MODULE_ID from '../moduleId';
import { mapState } from 'vuex';
import tenantStrategies from '../dutyActivities/tenantStrategies';

export default {
  name: 'DutyCardContent',
  mixins: [dutyMixin, commonMixin],
  props: {
    duty: Object,
    showDate: { type: Boolean, default: true },
    height: { type: String, required: false },
  },

  computed: {
    ...mapState(MODULE_ID, ['dutyActivities', 'dutyStops']),
    ...mapState({ tenant: (state) => state.profile.customerRelations.tenant }),
    thisDutyActivities() {
      return this.mx_getDutyActivities(this.duty, { tenant: this.tenant });
    },
    /**
     * Get first activity whose blockcode is not null
     */
    firstActivity() {
      return tenantStrategies.getFirstActivity({ moduleConfig: this.mx_moduleConfig, tenant: this.tenant, dutyActivities: this.thisDutyActivities });
    },
    lastActivity() {
      return tenantStrategies.getLastActivity({ moduleConfig: this.mx_moduleConfig, tenant: this.tenant, dutyActivities: this.thisDutyActivities });
    },
    locationFromTo() {
      const da = this.thisDutyActivities;
      if (da && da.length > 0 && this.firstActivity) {
        let start = this.firstActivity._startStop ? this.firstActivity._startStop.shortname : '';
        let lastDa = this.lastActivity;
        let end = lastDa._endStop ? lastDa._endStop.shortname : '';
        if (start && end) return `${start} - ${end}`;
      }
      return null;
    },
    dutyTime() {
      let time = '';
      if (this.firstActivity && this.firstActivity.fromMinutesAfterMidnight)
        time += this.mx_time(this.firstActivity.fromMinutesAfterMidnight, this.firstActivity) + ' - ';
      if (this.lastActivity && this.lastActivity.toMinutesAfterMidnight) time += this.mx_time(this.lastActivity.toMinutesAfterMidnight, this.lastActivity);
      return time;
    },
    vehicleLocation() {
      let rows = this.thisDutyActivities
        .filter((da) => da.fzgStandplatz || da.fzgStandplatz)
        .map((da) => `${da.fzgStandplatz}${da.fzgNummer ? ' / ' + da.fzgNummer : ''}`);
      return rows;
    },

    /** Might be not exactly precise */
    dutyDetails() {
      let duty = this.duty;
      if (duty._dutyActivities) {
        for (let i = 0; i < duty._dutyActivities.length; i++) {
          let dutyActivity = duty._dutyActivities[i];
          if (!isNaN(dutyActivity.blockcode) && dutyActivity.line) {
            let hasTracks =
              this.$store.getters['meinDienst/getDutyTracks']({
                dutyDateIsoString: duty.day,
                dutyStartMinutesAfterMidnight: duty._startMinutesAfterMidnight,
                dutyEndMinutesAfterMidnight: duty._endMinutesAfterMidnight,
                line: dutyActivity.line,
                track: dutyActivity.blockcode,
              }).length > 0;
            // // console.debug('hasTracks,dutyActivity.blockcode) && dutyActivity.line', hasTracks, dutyActivity.blockcode, dutyActivity.line);
            return { hasTracks, track: dutyActivity.blockcode, line: dutyActivity.line };
          }
        }
      }
      return null;
    },
  },
  methods: {},
};
</script>
